import {
	defaultModalProps,
	deleteBrokerModalProps,
	deleteBrokerModalSuccessProps,
} from "modal-tpyes";
import {
	useMediaQuery,
	useTheme,
	Dialog,
	makeStyles,
	Container,
	Typography,
	Button,
	Grid,
	Box,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
// import { useMutation,DELETE_BROKER_ACCOUNT, DELETE_SUBSCRIPTION_GQL } from 'src/graphql'
import {
	// deleteBrokerAccountProps,
	// deleteBrokerAccountResponse,
	deleteBrokerAccountResult,
} from "subsciption-types";
import { setDialog } from "src/actions";
import { useMutation } from "@apollo/client";
import { deleteInvestorAccount } from "src/graphql/mutations/investor";

interface stylesProp {
	useMobileUI: boolean;
}

const useStyles = makeStyles((theme) => ({
	root: (props: stylesProp) => ({
		borderRadius: theme.spacing(1),
		backgroundColor: "white",
		margin: "0px",
		minWidth: props.useMobileUI ? "440px" : "100%",
		padding: theme.spacing(3),
	}),
	closeIcon: {
		position: "absolute",
		color: theme.palette.primary.main,
		top: theme.spacing(2),
		left: theme.spacing(3),
		width: theme.spacing(3),
		height: theme.spacing(3),
	},
	container: {
		padding: theme.spacing(4),
	},
	textBlack: {
		color: "#000",
	},
	textGrey: {
		color: "grey",
	},
}));

const DeleteBrokerModal: React.FC<defaultModalProps> = ({
	open,
	// handleBack,
	handleClose,
	props: modalProps,
}) => {
	const theme = useTheme();
	const useMobileUI = useMediaQuery(theme.breakpoints.up("sm"));
	const dispatch = useDispatch();
	const styleProps = { useMobileUI: useMobileUI };
	const classes = useStyles(styleProps);
	const [props, setProps] = useState<deleteBrokerModalProps>();
	const [deleteAccount] = useMutation(deleteInvestorAccount);
	const [forceDelete, setForceDelete] = useState(true);

	void setForceDelete;

	const onClose = () => {
		handleClose();
	};

	const ModalProps = {
		paper: classes.root,
	};

	const openSuccessModal = (props: deleteBrokerModalSuccessProps) => {
		let deleteBrokerSuccessProps: deleteBrokerModalSuccessProps = props;
		dispatch(
			setDialog("deleteBrokerSuccessModal", true, deleteBrokerSuccessProps)
		);
	};

	const deleteBrokerAccount = () =>
		new Promise<deleteBrokerAccountResult>(async (resolve, reject) => {
			let deleteAccountParams = {
				username: props?.username,
			};
			try {
				let { data } = await deleteAccount({ variables: deleteAccountParams });
				resolve(data);
			} catch (err) {
				reject(err);
			}
		});

	const handleDeleteAccount = async () => {
		try {
			await deleteBrokerAccount();
			if (props) {
				openSuccessModal({
					isSuccess: true,
					username: props.username,
					brokerName: props.brokerName,
					accountNos: props.accountNos,
				});
			}
		} catch (err) {
			if (props) {
				openSuccessModal({
					isSuccess: false,
					username: props.username,
					brokerName: props.brokerName,
					accountNos: props.accountNos,
				});
			}
		}
	};

	useEffect(() => {
		if (modalProps) {
			let props: deleteBrokerModalProps = {
				accountNos: modalProps.accountNos,
				username: modalProps.username,
				brokerName: modalProps.brokerName,
				message: modalProps.message,
				messageTh: modalProps.messageTh,
			};
			setProps(props);
		}
	}, [modalProps]);

	return (
		<Dialog
			open={open || false}
			keepMounted
			onClose={onClose}
			classes={ModalProps}
			maxWidth="xl">
			{!!props && (
				<Container maxWidth="md" className={classes.container}>
					<Typography align="center" className={classes.textBlack}>
						{`${
							forceDelete
								? "ยืนยันการยกเลิกผูกบัญชี"
								: "ยืนยันการยกเลิกการติดตาม model ของ"
						} ${props?.brokerName}`}
					</Typography>
					<Box mt={2} />
					<Typography align="center" className={classes.textGrey}>
						{`${
							forceDelete
								? "ข้อมูลการติดตาม model ทั้งหมดของ"
								: "บัญชีที่ไม่ได้ติดตาม model ของ"
						} ${props?.username}`}
					</Typography>
					<Typography align="center" className={classes.textGrey}>
						{`ภายใต้ account number`}
					</Typography>
					{/* {
          props?.accountNos?.map((account)=>(
            <Typography key={`del-${account.accountNo}`} align="center" className={classes.textGrey}>
              {account.accountNo}
            </Typography>
          ))
        } */}
					<Typography align="center" className={classes.textGrey}>
						จะถูกลบ
					</Typography>
				</Container>
			)}
			<Grid container justifyContent="center">
				<Button
					variant="text"
					onClick={handleClose}
					className={classes.textBlack}>
					ย้อนกลับ
				</Button>
				<Box mr={3} />
				<Button
					color="secondary"
					variant="contained"
					onClick={handleDeleteAccount}
					style={{ color: "white" }}>
					ยืนยัน
				</Button>
			</Grid>
		</Dialog>
	);
};

export default DeleteBrokerModal;
